export const pagination = {
  next: '下頁',
  more: '更多',
}
